import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchFullYearResults } from '@apis/fundamentals';
import type {
  FullYearForecastType,
  FullYearResultsApiData,
} from '@app-types/performanceTrendsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

const isFullYearForecastType = (value: string): value is FullYearForecastType =>
  value === 'consensus' || value === 'company';

const isValidYears = (value: number): boolean =>
  Number.isFinite(value) && value > 0;

/**
 * React Query hook for the é€šæœŸæ¥­ç¸¾æŽ¨ç§» Annual section.
 * Reads ticker/mkt from the router location so URL changes refetch; the token
 * only gates the query and is attached by the fundamentals client interceptor.
 */
export const useFullYearResults = (
  forecastType: FullYearForecastType,
  years: number,
) => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());
  const hasValidForecastType = isFullYearForecastType(forecastType);
  const hasValidYears = isValidYears(years);

  return useQuery<FullYearResultsApiData>({
    queryKey: ['fundamentals', 'full-year-results', ticker, mkt, forecastType, years],
    queryFn: () => fetchFullYearResults({
      ticker: ticker as string,
      mkt: mkt as string,
      forecastType,
      years,
    }),
    enabled: Boolean(ticker && mkt && hasToken && hasValidForecastType && hasValidYears),
    staleTime: 60_000,
    retry: 1,
  });
};
